var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('loader'),_c('div',{staticClass:"md:flex"},[_c('div',{staticClass:"md:w-3/4"},[_c('router-view')],1),_c('div',{staticClass:"md:w-1/4"},[_c('categories'),_c('tags')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }